// extracted by mini-css-extract-plugin
export default {"advertCardListStub":"c-a_fG"};